import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import {FormsModule, NgForm} from "@angular/forms";
import {Prestazione} from "../../models/prestazione.model";
import moment from "moment";
import {PrenotazioneService} from "../../services/prenotazione.service";
import {Prenotazione} from "../../models/prenotazione.model";
import {of, switchMap} from "rxjs";
import Swal from "sweetalert2";

@Component({
  selector: 'app-prenotazione-create',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
  ],
  templateUrl: './create.component.html',
  styleUrl: './create.component.css'
})
export class CreateComponent {

  //Input da form
  prenotazione: any;
  nome: any;
  cognome: any;
  cellulare: any;
  prezzo: any;
  note: any;
  tempoMedio: any;
  abbonamento: any;

  //Variabili
  durata: number = 30;
  minuti: number[] = Array.from({length: this.durata}, (_, i) => i + 1);
  private _prestazione: Prestazione | null = null;

  @Input()
  set prestazione(prestazione: Prestazione | null) {
    this._prestazione = prestazione;
    if (prestazione && prestazione.durata) {
      this.durata = prestazione.durata;
      this.tempoMedio = prestazione.tempoMedio;
      this.minuti = Array.from({length: this.durata}, (_, i) => i + 1);
    }
    // TODO calcolo automatico tempo medio UAT commit
  }

  get prestazione(): Prestazione | null {
    return this._prestazione;
  }

  @Input() date: moment.Moment = moment();
  @Input() hour: number = 9;
  @Input() minutes: number = 20;
  @Input() isVisible: boolean = false;
  @Output() closeModal = new EventEmitter<void>();

  constructor(public prenotazioneService: PrenotazioneService) {
  }

  // Mette in maiuscolo l'input
  onInputChange(event: Event) {
    const input = event.target as HTMLInputElement;
    input.value = input.value.toUpperCase();
  }

  onClose() {
    this.closeModal.emit();
  }

  onSave(form: NgForm) {
    if(form.invalid || this.prestazione === null || this.prestazione._id === null) {
      console.log("Form invalid")
      return;
    }

    //Calcolo inizio e fine
    const oreFormattate = this.hour.toString().padStart(2, '0');
    const minutiFormattati = this.minutes.toString().padStart(2, '0');
    const tempo = `${oreFormattate}:${minutiFormattati}`;
    const inizio = moment(this.date.format('YYYY-MM-DD') + ' ' + tempo);
    const fine = inizio.clone().add(this.prestazione.durata, 'minutes');

    //Creo la prenotazione
    this.prenotazione = new Prenotazione(
      this.prestazione._id,
      this.nome? this.nome : "Cliente",
      inizio.format("YYYY-MM-DD HH:mm"),
      fine.format("YYYY-MM-DD HH:mm"),
      false,
    '',
    this.cognome? this.cognome : "",
    this.cellulare? this.cellulare : "",
    this.prezzo,
    this.note? this.note : "",
      this.tempoMedio,
      this.nome? '' : moment().format('YYYY-MM-DD HH:mm'),
      undefined,
      this.abbonamento? this.abbonamento : null
    );


    this.prenotazioneService.createPrenotazione(this.prenotazione)
      .pipe(
        switchMap((response) => {
          console.log("Prenotazione creata", response);
          form.resetForm();
          this.closeModal.emit();
          return of(response);
        })
      )
      .subscribe({
        error: (error) => {
          console.error("Errore nella creazione della prenotazione", error);

          Swal.fire({
            icon: 'error',
            title: 'Ops...',
            text: "Errore nell'inserimento della prenotazione",
            confirmButtonColor: '#050A30'
          });

        }
      });

  }
}
